// FeedbackTemplates.js
const templates = [
  {
    name: "Restaurant Feedback",
    title: "Restaurant Feedback",
    description: "A comprehensive feedback form for restaurants, covering food quality, service, ambiance, value, and overall experience with NPS and comments.",
    questions: [
      { id: 1, type: "rating", label: "Food Quality", required: true, style: "smiley" },
      { id: 2, type: "rating", label: "Service Quality", required: true, style: "smiley" },
      { id: 3, type: "rating", label: "Ambiance", required: true, style: "smiley" },
      { id: 4, type: "rating", label: "Value for Money", required: true, style: "smiley" },
      { id: 5, type: "rating", label: "Overall Experience", required: true, style: "smiley" },
      { id: 6, type: "nps", label: "How likely are you to recommend us?", required: false },
      { id: 7, type: "text", label: "Additional Comments", required: false, placeholder: "Tell us more..." },
    ],
    branding: {
      themeColor: "#ff4100",
      titleColor: "#000000",
      titleFontSize: 2,
      showLogo: true,
      logoSrc: "",
      buttonStyle: "rounded",
      background: "solid",
      backgroundValue: "#ffffff",
      thankYou: "Thank you for your feedback!",
      redirectUrl: "",
      conditionalRedirect: {
        enabled: false,
        thresholdQuestionId: null,
        threshold: 7,
        goodUrl: "",
        badUrl: "",
        goodMessage: "Thank you! Please rate us here.",
        badMessage: "Thank you for your feedback!"
      }
    },
    settings: { anonymous: true, expiry: "", notifications: false, recipients: "", access: "public", language: "en" }
  },
  {
    name: "Front Office Feedback",
    title: "Front Office Feedback",
    description: "A feedback form for front office services, evaluating staff friendliness, check-in efficiency, cleanliness, with NPS and improvement suggestions.",
    questions: [
      { id: 1, type: "rating", label: "Staff Friendliness", required: true, style: "star" },
      { id: 2, type: "rating", label: "Check-in Efficiency", required: true, style: "star" },
      { id: 3, type: "rating", label: "Cleanliness", required: true, style: "star" },
      { id: 4, type: "nps", label: "Likelihood to Recommend", required: false },
      { id: 5, type: "text", label: "Suggestions for Improvement", required: false, placeholder: "Any suggestions?" },
    ],
    branding: {
      themeColor: "#007bff",
      titleColor: "#000000",
      titleFontSize: 2,
      showLogo: true,
      logoSrc: "",
      buttonStyle: "rounded",
      background: "solid",
      backgroundValue: "#f8f9fa",
      thankYou: "Thank you for your feedback!",
      redirectUrl: "",
      conditionalRedirect: {
        enabled: false,
        thresholdQuestionId: null,
        threshold: 7,
        goodUrl: "",
        badUrl: "",
        goodMessage: "Thank you! Please rate us here.",
        badMessage: "Thank you for your feedback!"
      }
    },
    settings: { anonymous: true, expiry: "", notifications: false, recipients: "", access: "public", language: "en" }
  },
  {
    name: "Housekeeping Feedback",
    title: "Housekeeping Feedback",
    description: "A feedback form to evaluate cleanliness, comfort, housekeeping responsiveness, and staff professionalism.",
    questions: [
      { id: 1, type: "rating", label: "Room Cleanliness", required: true, style: "star" },
      { id: 2, type: "rating", label: "Comfort of Room & Amenities", required: true, style: "star" },
      { id: 3, type: "rating", label: "Housekeeping Responsiveness", required: true, style: "star" },
      { id: 4, type: "rating", label: "Staff Professionalism", required: false, style: "star" },
      { id: 5, type: "nps", label: "Would you recommend our housekeeping service?", required: false },
      { id: 6, type: "text", label: "Additional Suggestions", required: false, placeholder: "How can we improve housekeeping?" },
    ],
    branding: {
      themeColor: "#28a745",
      titleColor: "#000000",
      titleFontSize: 2,
      showLogo: true,
      logoSrc: "",
      buttonStyle: "rounded",
      background: "solid",
      backgroundValue: "#ffffff",
      thankYou: "Thank you for your valuable feedback on housekeeping!",
      redirectUrl: "",
      conditionalRedirect: {
        enabled: false,
        thresholdQuestionId: null,
        threshold: 7,
        goodUrl: "",
        badUrl: "",
        goodMessage: "We appreciate your positive feedback!",
        badMessage: "We’ll work to improve based on your input."
      }
    },
    settings: { anonymous: true, expiry: "", notifications: false, recipients: "", access: "public", language: "en" }
  },
  {
    name: "Banquet/Event Feedback",
    title: "Banquet & Event Feedback",
    description: "A feedback form for guests attending events, focusing on venue, arrangements, catering, staff coordination, and overall satisfaction.",
    questions: [
      { id: 1, type: "rating", label: "Venue Setup & Cleanliness", required: true, style: "star" },
      { id: 2, type: "rating", label: "Event Staff Coordination", required: true, style: "star" },
      { id: 3, type: "rating", label: "Catering Quality", required: true, style: "smiley" },
      { id: 4, type: "rating", label: "Audio/Visual Arrangements", required: false, style: "star" },
      { id: 5, type: "rating", label: "Overall Event Experience", required: true, style: "smiley" },
      { id: 6, type: "nps", label: "Would you recommend hosting events with us?", required: false },
      { id: 7, type: "text", label: "Suggestions for Improvement", required: false, placeholder: "What can we do better for future events?" },
    ],
    branding: {
      themeColor: "#6f42c1",
      titleColor: "#000000",
      titleFontSize: 2,
      showLogo: true,
      logoSrc: "",
      buttonStyle: "rounded",
      background: "solid",
      backgroundValue: "#f4f4f4",
      thankYou: "Thank you for sharing your event experience!",
      redirectUrl: "",
      conditionalRedirect: {
        enabled: false,
        thresholdQuestionId: null,
        threshold: 8,
        goodUrl: "",
        badUrl: "",
        goodMessage: "We’re glad your event went well!",
        badMessage: "We’ll work harder to improve your event experience."
      }
    },
    settings: { anonymous: true, expiry: "", notifications: true, recipients: "events@hotel.com", access: "public", language: "en" }
  },
  {
    name: "Spa & Wellness Feedback",
    title: "Spa & Wellness Feedback",
    description: "A feedback form for spa and wellness services, evaluating treatments, therapist professionalism, ambiance, facilities, and relaxation experience.",
    questions: [
      { id: 1, type: "rating", label: "Treatment Quality", required: true, style: "star" },
      { id: 2, type: "rating", label: "Therapist Professionalism", required: true, style: "star" },
      { id: 3, type: "rating", label: "Ambiance & Relaxation", required: true, style: "smiley" },
      { id: 4, type: "rating", label: "Spa Facilities (steam, sauna, showers)", required: false, style: "star" },
      { id: 5, type: "rating", label: "Value for Money", required: true, style: "smiley" },
      { id: 6, type: "nps", label: "Would you recommend our spa to friends/family?", required: false },
      { id: 7, type: "text", label: "Additional Feedback", required: false, placeholder: "Share your spa experience..." },
    ],
    branding: {
      themeColor: "#e83e8c",
      titleColor: "#000000",
      titleFontSize: 2,
      showLogo: true,
      logoSrc: "",
      buttonStyle: "rounded",
      background: "solid",
      backgroundValue: "#fff5f8",
      thankYou: "Thank you for your feedback! We hope you feel rejuvenated.",
      redirectUrl: "",
      conditionalRedirect: {
        enabled: false,
        thresholdQuestionId: null,
        threshold: 8,
        goodUrl: "",
        badUrl: "",
        goodMessage: "We’re glad you enjoyed your spa session!",
        badMessage: "Thank you for your feedback, we’ll make improvements."
      }
    },
    settings: { anonymous: true, expiry: "", notifications: false, recipients: "spa@hotel.com", access: "public", language: "en" }
  }
];

export default templates;
